/** Ressources de traduction statiques ; les clés restent vérifiées par TypeScript. */
import textes from './traductions/bons-publics.json' with { type: 'json' };
export const TEXTES_BONS_PUBLICS = textes;
//# sourceMappingURL=textes-bons-publics.js.map